function loadJs (url) {
  var script = document.createElement('script')
  script.type = 'text/javascript'
  script.src = url
  document.head.appendChild(script)
}

/**
 * 为 IE 11 单独加载 ES6 支持库
 */
(function () {
  if (navigator.userAgent.indexOf('rv:11.0') > -1) {
    loadJs('./js/es6-shim.min.js')
  }
})()
